import { http } from "..";

/**
 * Create review
 *
 * @param {object} reviewBody
 * @returns axios http response
 */
export const createReview = (reviewBody: {}) => {
  return http.post("/app-reviews/create", reviewBody);
};
